/// <reference path="Utilities/_reference.ts" />

module YVR.Carousel {
	function init() {
		$('.yvr-fact-set-carousel').slick({
			adaptiveHeight: false,
			dots: false,
			infinite: true,
			speed: 300,
			slidesToShow: 3,
			slidesToScroll: 3,
			responsive: [
				{
					breakpoint: 1200,
					settings: {
						adaptiveHeight: false,
						slidesToShow: 2,
						slidesToScroll: 2
					}
				},
				{
					breakpoint: 768,
					settings: {
						adaptiveHeight: true,
						slidesToShow: 1,
						slidesToScroll: 1
					}
				}
			]
		});

		$('.yvr-facility-banner-carousel').each((index, elem) => {
			if (elem.children.length > 1) {
				$(elem).slick({
					adaptiveHeight: true,
					dots: true,
					infinite: true,
					speed: 300,
					slidesToShow: 1,
					slidesToScroll: 1
				});
			}
		});
	}

	init();
}
